<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title">
        <span>
          {{tab_name}}
        </span>
        <button *ngIf="query" (click)="toggleQueryBox()" class="btn btn-link p-0 eye-btn">
          <i class="bi" [matTooltip]="showQueryBox ? 'Hide Query' : 'View Query'"
            [ngClass]="showQueryBox ? 'bi-eye-slash' : 'bi-eye'" matTooltipPosition="above">
          </i>
        </button>
      </div>

      <div *ngIf="showQueryBox && query" class="alert alert-info query-alert" role="alert">
        {{ query || 'No query found' }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col m-10" style="margin:20px;">
      <div style="margin-bottom: 10px;">
        This table shows public companies assigned to the same GICS peer group of the selected company based on patent
        similarity.
      </div>

      <div class="alert alert-info" role="alert" *ngIf="!showResults && !competitors_list_loading_failed">
        <p>
          This result is currently available only for companies classified under the GICS. Stay tuned as we work on
          adding this feature for all companies.
        </p>
      </div>

      <div class="card keywords" *ngIf="showResults">
        <h3>Public Competitors</h3>


        <div class="alert alert-danger" role="alert" *ngIf="showResults && competitors_list_loading_failed">
          <p>
            Unfortunately, we weren't able to load the results. Please try again later, or for more assistance, please
            contact
            <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>
        <div class="empty-state" *ngIf="showDataMissing">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Companies Found</h4>
            <p>No public companies were found relevant to the chosen company.
            </p>
          </div>
        </div>

        <div class="spinner-border text-primary" role="status"
          *ngIf="showResults && competitors_list.length==0 && !this.competitors_list_loading_failed">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="company-category-description"
          style="margin: 10px 0;background-color: #f8f9fa; border-radius: 5px;">
          <div class="description special-text">
            <ng-container *ngFor="let company of competitors_list">
              <div *ngIf="company.entityid === entityids![0]">
                <span class="highlight" [innerHTML]="getCategoryDescription(company)"></span>
                <!-- info icon -->
                <i class="bi bi-info-circle"
                  [matTooltip]="'Higher level GICS classifications are used when the sub-industry classification contains less than 50 members.'"
                  matTooltipPosition="above" style="margin-left: 8px; cursor: pointer;"></i>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Category Tabs -->
        <div class="category-tabs"
          *ngIf="showResults && competitors_list.length > 0 && !competitors_list_loading_failed">
          <div class="tab-buttons">
            <button *ngFor="let category of categoryTabs" class="category-tab-btn"
              [class.active]="selectedCategory === category.key" (click)="selectCategory(category.key)">
              {{ category.label }}
            </button>
          </div>

          <!-- Category Description -->
          <div class="category-description" *ngIf="getCurrentCategoryDescription()">
            <p>
              {{ getCurrentCategoryDescription() }}
              <i class="bi bi-info-circle" [matTooltip]="getCurrentCategoryTooltip()" matTooltipPosition="above"
                style="margin-left: 8px; cursor: pointer;"></i>
            </p>
          </div>

          <!-- No Results Message -->
          <div class="no-results-message" *ngIf="!hasCategoryResults() && showResults && competitors_list.length > 0"
            style="margin: 15px 0; padding: 20px; background-color: #fff3cd; border-radius: 5px; border-left: 4px solid #ffc107; text-align: center;">
            <div class="no-results-text">
              <i class="bi bi-exclamation-triangle" style="color: #856404; margin-right: 8px;"></i>
              <strong>No companies found</strong> for the selected <strong>{{ getCurrentCategoryLabel() }}</strong>
              criteria.
              <br>
              <small style="color: #856404;">Try selecting a different category or adjusting your filters.</small>
            </div>
          </div>
        </div>

        <div class="filters" *ngIf="showResults && competitors_list.length > 0">
          <mat-slide-toggle (change)="filterFavorites()">
            Show <i class="bi bi-star"></i> Selection Only
          </mat-slide-toggle>

          <input type="text" class="form-control" style="margin-left:20px;" placeholder="Search by Company Name"
            [(ngModel)]="searchQuery" (ngModelChange)="applyFilters()" style="width: 270px;">

          <button class="btn btn-primary add-selection-to-watchlist-button" style="margin-left:20px;background:#1E3A8A;color:#FFFFFF;"
            [disabled]="getSelectedEligibleCompanies().length === 0" (click)="openAddToWatchlist()">
            <i class="bi bi-bookmark-plus"></i>
            Add Selection to Watchlist
          </button>

          <button class="btn search-button" style="margin-left:20px;background:#E5E7EB;color:#1F2937;" (click)="downloadExcel()"
            matTooltip="Download Excel">
            <i class="bi bi-download"></i>
          </button>
        </div>

        <table class="table table-hover table-condensed" *ngIf="showResults && competitors_list.length > 0">
          <thead>
            <tr style="background-color: #96c242;">
              <th scope="col" style="width: 5%;">Select</th>
              <th scope="col" style="width: 5%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('rank')">
                Rank
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('rank')"></i>
              </th>
              <th scope="col" style="width: 15%;">
                Company
              </th>
              <th scope="col" style="width: 10%;">
                <div class="dropdown" style="font-weight:normal;">
                  <button class="btn country-dropdown-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-bs-toggle="dropdown" aria-expanded="false" style="font-size: 14px;">
                    Country / <br>Market
                    <span *ngIf="(countriesControl.value?.length ?? 0) > 0" class="badge bg-light text-dark ms-1">
                      {{ countriesControl.value!.length }}
                    </span>
                  </button>
                  <div class="dropdown-menu p-3" aria-labelledby="dropdownMenuButton"
                    style="width: 270px; max-height: 300px; overflow-y: auto;">
                    <div *ngFor="let region of countryFilterOptions">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <input type="checkbox" [checked]="isRegionFullySelected(region)"
                            (change)="toggleRegionSelection(region)" id="{{ region.region }}-region-checkbox"
                            class="form-check-input me-2">
                          <label for="{{ region.region }}-region-checkbox" class="form-check-label">
                            {{ region.region }}
                          </label>
                        </div>
                        <button class="btn btn-sm btn-light"
                          (click)="toggleExpand(region.region); $event.stopPropagation();">
                          <i class="bi" [ngClass]="isExpanded(region.region) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </button>
                      </div>
                      <div *ngIf="isExpanded(region.region)" class="ms-3">
                        <div *ngFor="let country of region.countries" class="form-check">
                          <input type="checkbox" class="form-check-input" [id]="'country-' + country.code"
                            [checked]="(countriesControl.value ?? []).includes(country.code)"
                            (change)="toggleCountrySelection(country.code, region)">
                          <label class="form-check-label" [for]="'country-' + country.code">
                            {{ country.name }}
                          </label>
                        </div>
                      </div>
                      <hr class="my-2" *ngIf="region !== countryFilterOptions[countryFilterOptions.length - 1]">
                    </div>
                  </div>
                </div>
              </th>
              <th style="width: 10%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('size')"
                [ngClass]="{'column-highlight-size': selectedCategory === 'size_leaders'}">
                Size (10y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'Invention Count (10y). Number of inventions filed by the company or its subsidiaries, published in the last 120 months. Quantifies the total size of IP assets of the company.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('size')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'size_leaders'"
                  style="margin-left: 5px; color: #333; font-size: 18px;"></i>
              </th>
              <th scope="col" style="width: 14%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('growth')"
                [ngClass]="{'column-highlight-growth': selectedCategory === 'growth_leaders'}">
                Growth (1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'% Change, 1y. Percentage value showing how the innovation activity in the last year compares to the previous year. Quantifies the increase or decrease in the company\'s innovation efforts. Values in parentheses show the number of inventions published in the last 12 months.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('growth')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'growth_leaders'"
                  style="margin-left: 5px; color: #333; font-size: 18px;"></i>
              </th>
              <th scope="col" style="width: 10%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('quality')"
                [ngClass]="{'column-highlight-quality': selectedCategory === 'quality_leaders'}">
                Quality (0-100,1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'Average of the quality score of inventions of the last 12 months. Quant IP Quality Score is a proprietary metric to evaluate the quality of an invention upon first publication. Taking into grant robustness, market potential, and citation potential into account, a larger average score at a company level indicates a higher patent portfolio value.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('quality')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'quality_leaders'"
                  style="margin-left: 5px; color: #333; font-size: 18px;"></i>
              </th>
              <th scope="col" style="width: 15%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='innovation_score' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('innovation_score')"
                [ngClass]="{'column-highlight-innovation': selectedCategory === 'innovation_leaders' || selectedCategory === 'upcoming'}">
                Innovation Score
                <i class="bi bi-info-circle"
                  matTooltip="Current Innovation Score of the company relative to its GICS Peer Group."
                  style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('innovation_score')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'innovation_leaders'"
                  style="margin-left: 5px; color: #333; font-size: 18px;"></i>
              </th>
              <th scope="col" style="width: 12%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='score_change' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('score_change')"
                [ngClass]="{'column-highlight-upcoming': selectedCategory === 'upcoming'}">
                Score Change (3 months)
                <i class="bi bi-info-circle" matTooltip="Change in Innovation Score in the last 3 months."
                  style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>
                <i class="bi" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('score_change')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'upcoming'"
                  style="margin-left: 5px; color: #333; font-size: 18px;"></i>
              </th>
              <th scope="col" style="width: 11%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='rank_change' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('rank_change')">
                Rank Change (%, 3 months)
                <i class="bi bi-info-circle" matTooltip="Percentile ranks climbed by the company in the last 3 months."
                  style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>
                <i class="bi" *ngIf="selectedCategory === 'all_competitors'" [ngClass]="getSortIcon('rank_change')"></i>
              </th>
              <th style="width: 10%;"> Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let company of filteredCompanyList | paginate: {id: 'pag_public', itemsPerPage: 20, currentPage: paginator_1_page }"
              [ngClass]="(company.entityid === this.entityid) ? 'highlight':'normal'">
              <td>
                <div class="action-cell">
                  <button (click)="toggleCompanySelection(company)" class="btn btn-light action-star-btn"
                    [class.selected]="isCompanySelected(company.entityid)"
                    [matTooltip]="isCompanySelected(company.entityid) ? 'Deselect' : 'Select'">
                    <i class="bi"
                      [ngClass]="isCompanySelected(company.entityid) ? 'bi-star-fill text-warning' : (company.favorite ? 'bi-star-fill text-warning' : 'bi-star')"></i>
                  </button>
                </div>
              </td>
              <td [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'">{{ company.rank }}
              </td>
              <td>
                <div class="text" style="max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                " matTooltip="{{company.entity_name}}">
                  {{ company.entity_name }}
                </div>
                <div class="isin" *ngIf="company.isin" style="font-size: 12px;color: cadetblue;">
                  {{company.isin}} <a *ngIf="company.webpage"
                    [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-globe2" style="color: grey;"></i>
                  </a>
                </div>
                <div class="isin" *ngIf="!company.isin" style="font-size: 12px;color: cadetblue;">
                  {{company.companytype}} <a *ngIf="company.webpage"
                    [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-globe2" style="color: grey;"></i>
                  </a>
                </div>
              </td>
              <td>{{ company.country }}</td>
              <td [ngClass]="{'column-highlight-size': selectedCategory === 'size_leaders'}"
                [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'">
                {{ company.invention_count_120m | nullableNumber: '1.0-0' }}
              </td>
              <td [ngClass]="{'column-highlight-growth': selectedCategory === 'growth_leaders'}"
                [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'">
                <div>
                  {{ company.relative_growth_12m | nullableNumber: '1.0-1' }} %
                </div>
                <div style="font-size: 12px;color: cadetblue;"> ({{ company.invention_count_12m | nullableNumber:
                  '1.0-0' }} inventions)</div>
              </td>
              <td [ngClass]="{'column-highlight-quality': selectedCategory === 'quality_leaders'}"
                [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'">
                {{ company.quality_average_12m | nullableNumber: '1.0-1' }}
              </td>
              <td [class.sorted-col]="sortColumn==='innovation_score'"
                [ngClass]="{'column-highlight-innovation': selectedCategory === 'innovation_leaders' || selectedCategory === 'upcoming'}">
                <div class="score-bar-container">
                  <div class="score-bar">
                    <div class="score-bar-fill" [ngClass]="getBarColor(company.innovation_score)"
                      [style.width.%]="company.innovation_score"></div>
                  </div>
                  <span class="score-label">{{ company.innovation_score | nullableNumber: '1.0-1' }}</span>
                </div>
              </td>
              <td [class.sorted-col]="sortColumn==='score_change'"
                [ngClass]="{'column-highlight-upcoming': selectedCategory === 'upcoming'}">
                <div class="change-metric"
                  *ngIf="company.innovation_score_change !== null && company.innovation_score_change !== undefined"
                  [ngClass]="getBracketColor(company.score_bracket)"
                  [matTooltip]="getBracketTooltip(company.score_bracket)"
                  [matTooltipDisabled]="!getBracketTooltip(company.score_bracket)">
                  <i class="bi" [ngClass]="getBracketArrow(company.score_bracket)"></i>
                  <span>
                    <span *ngIf="company.innovation_score_change > 0.01">+</span>
                    {{company.innovation_score_change | nullableNumber: '1.0-1' }}
                  </span>
                </div>
              </td>
              <td [class.sorted-col]="sortColumn==='rank_change'">
                <div class="change-metric"
                  *ngIf="company.pct_rank_climbed !== null && company.pct_rank_climbed !== undefined"
                  [ngClass]="getBracketColor(company.rank_bracket)"
                  [matTooltip]="getBracketTooltip(company.rank_bracket)"
                  [matTooltipDisabled]="!getBracketTooltip(company.rank_bracket)">
                  <i class="bi" [ngClass]="getBracketArrow(company.rank_bracket)"></i>
                  <span class="value">
                    <span [ngClass]="company.rank_bracket === 3 ? '' : 'font-weight-bold'">
                      <span *ngIf="company.pct_rank_climbed > 0.01">+</span>
                      {{company.pct_rank_climbed | nullableNumber: '1.0-1' }}%
                    </span><br>
                    <span style="font-weight: normal;">
                      ({{company.rank_climbed}} ranks)
                    </span>
                  </span>
                </div>
              </td>
              <td>
                <button class="btn search-button" (click)="newSearch(company)"
                  [disabled]="!(company.gsubind_extended || company.gsubind)"
                  *ngIf="(company.entityid !== this.entityid)">
                  <i class="bi bi-box-arrow-up-right" style="color: black;font-size: 18px;"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <pagination-controls id="pag_public" [maxSize]="5" (pageChange)="paginator_1_page = $event"
          style="align-items: flex-start;" *ngIf="filteredCompanyList.length>0">
        </pagination-controls>
      </div>
    </div>
  </div>
</div>